<template>
  <VDialog v-model="dialog" width="600px">
    <VCard>
      <VBtn absolute style="right: 0" class="mt-1" icon @click="close">
        <VIcon>mdi-close</VIcon>
      </VBtn>
      <VCardTitle class="text-center pb-0"
        >{{ warehouse.warehouseName }} => {{ warehouse.column
        }}{{ warehouse.row }}:{{ shellProductsData.columnIndex
        }}{{ shellProductsData.rowIndex }}</VCardTitle
      >
      <VCardTitle class="text-center pt-0">{{
        $t("placedProducts")
      }}</VCardTitle>
      <VCardText>
        <VExpansionPanels>
          <VExpansionPanel
            v-for="(
              /**
               * @type {Object}
               * @property placedDate
               * @property placedByName
               */ item,
              i
            ) in productInfo"
            :key="i"
          >
            <VExpansionPanelHeader class="font-weight-bold">
              {{ item.name }}
            </VExpansionPanelHeader>
            <VExpansionPanelContent>
              <VList dense class="pb-0 pt-0">
                <VListItemGroup>
                  <VListItem class="pl-0">
                    <span class="font-weight-bold pr-1"
                      >{{ $t("nContract") }}:
                    </span>
                    {{ item.contractNumber }}
                  </VListItem>
                  <VListItem class="pl-0">
                    <span class="font-weight-bold pr-1"
                      >{{ $t("placedDate") }}:
                    </span>
                    {{ item.placedDate | dateParse }}
                  </VListItem>
                  <VListItem class="pl-0">
                    <span class="font-weight-bold pr-1"
                      >{{ $t("whoPosted") }}:
                    </span>
                    {{ item.placedByName }}
                  </VListItem>
                  <VListItem class="pl-0">
                    <span class="font-weight-bold pr-1"
                      >{{ $t("quantity") }}:
                    </span>
                    {{ item.count }}
                    {{ item[`unit_type_name_${$i18n.locale}`] }}
                  </VListItem>
                </VListItemGroup>
              </VList>
            </VExpansionPanelContent>
          </VExpansionPanel>
        </VExpansionPanels>
        <VBtn
          class="mt-4 d-block mr-auto ml-auto"
          v-if="!cellInfo.full"
          color="success"
          @click="$emit('placeHere', { [cellInfo.id]: true })"
          >{{ $t("placeInFreeSpace") }}</VBtn
        >
      </VCardText>
    </VCard>
  </VDialog>
</template>

<script>
export default {
  data() {
    return {
      dialog: false,
      productInfo: [],
      shellProductsData: {
        columnIndex: null,
        rowIndex: null,
        carriageId: null,
      },
    };
  },
  props: {
    warehouse: {
      type: Object,
      required: true,
    },
    cellInfo: {
      type: Object,
      required: true,
    },
  },
  methods: {
    open(columnIndex, rowIndex, carriageId) {
      this.dialog = true;
      this.shellProductsData.columnIndex = columnIndex;
      this.shellProductsData.rowIndex = rowIndex;
      this.shellProductsData.carriageId = carriageId;
      this.getProductsInsideCell();
    },
    async getProductsInsideCell() {
      try {
        this.showLoading();
        const {
          data: { data },
        } = await this.$http.get("product-item/get-by-carriage", {
          params: { carriageId: this.shellProductsData.carriageId },
        });
        this.productInfo = data;
      } catch (e) {
        this.setResponseError({ error: e });
        return Promise.resolve([]);
      } finally {
        this.clearLoading();
      }
    },
    close() {
      this.dialog = false;
    },
  },
};
</script>
